<template>
  <v-container fluid>
    <v-card>
      <v-snackbar
        :timeout="30000"
        :top="true"
        :color="toastColor"
        v-model="toastEnable"
      >
        {{ toastText }}
        <v-btn dark flat @click.stop="toastEnable = false">{{ $t('close') }}</v-btn>
      </v-snackbar>
    </v-card>

    <v-layout>
      <v-flex>
        <v-btn dark bottom right color="primary" @click="showAddUserDialog" title="add user">
          <v-icon dark>add</v-icon> {{ $t('staff') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout class="subheading" align-baseline>
      <v-flex v-bind="flexAttr">{{ $t('name') }}</v-flex>
      <v-flex v-bind="flexAttr" class="text-xs-left">{{ $t('email') }}</v-flex>
      <v-flex xs12 md3 class="text-xs-left">{{ $t('role') }}</v-flex>
      <v-flex v-if="isWarehouse" xs12 md3 class="text-xs-left">{{ $t('warehouseSite') }}</v-flex>
      <v-flex xs12 md2 class="text-xs-center">{{ $t('note') }}</v-flex>
      <v-flex xs12 md2 class="text-xs-center">{{ $t('actions') }}</v-flex>
    </v-layout>
    <v-divider class="mb-3" ></v-divider>
    <v-layout align-baseline v-for="(item, index) in users" :key="item.name + index">
      <v-flex v-bind="flexAttr">
        <div>{{item.name}}</div>
        <div v-if="!!item.lastLoginTime">{{toTimestampString(new Date(item.lastLoginTime))}}</div>
      </v-flex>
      <v-flex v-bind="flexAttr" class="text-xs-left"><p style="text-align: left">{{ item.email }}</p></v-flex>
      <v-flex xs12 md3 class="text-xs-left"><v-chip v-for="role in item.roles" :key="role">{{ permissionValueToText.get(role) }}</v-chip></v-flex>
      <v-flex v-if="isWarehouse" xs12 md3 class="text-xs-left">
        <v-chip 
          v-for="site in getWarehouseSitesNames(item.sites, index)" 
          :key="site"
          :class="{ whiteColor: site === 'ALL' }"
          :color="site === 'ALL' ? 'primary' : 'default'">
          {{ site }}
        </v-chip>
      </v-flex>
      <v-flex xs12 md2 class="text-xs-center">
        <div class="text-overflow-hide" style="cursor: pointer" :ref="`${item.email}`" @click="toggleOverflowStyle(`${item.email}`)">{{item.note}}</div>
      </v-flex>
      <v-flex xs12 md2 class="text-xs-center">
        <v-btn dark color="primary" flat @click.stop="showEditUserDialog(item)" v-if="index !== 0">Edit</v-btn>
        <v-btn dark color="primary" flat @click.stop="removeUser(item)" v-if="index !== 0">Delete</v-btn>
        <span v-else>{{ $t('owner') }}</span>
      </v-flex>
    </v-layout>
    <PermissionEditPopup
      :isEdit="isEdit"
      v-model="roleEditDialog"
      v-if="roleEditDialog"
      :initUser="userInEdit"
      :actionFunc="isEdit ? editUser : addUser"
      :isWarehouseOwner="isWarehouseOwner"
    />
  </v-container>
</template>

<script>
import SimpleTextPopup from './SimpleTextPopup'
import PermissionEditPopup from './PermissionEditPopup'
import {timeTools} from '../utils/tools'

export default {
  name: 'Permission',
  components: {
    SimpleTextPopup,
    PermissionEditPopup
  },
  mixins: [timeTools],
  data () {
    return {
      toastColor: 'error',
      toastEnable: false,
      toastText: '',
      roleEditDialog: false,
      userInEdit: {},
      isEdit: ''
    }
  },
  computed: {
    warehouseSites () {
      return this.$store.getters.warehousesSites
    },
    isWarehouseOwner () {
      const { roles = [] } = this.$store.getters.user || {}
      return roles.includes('warehouseOwner')
    },
    users () {
      return this.$store.getters.warehouseInfo.users
    },
    permissionValueToText () {
      return this.$store.getters.permissionValueToText
    },
    isWarehouse () {
      return this.$store.getters.activeWarehouse
    },
    flexAttr () {
      let md = 'md3'
      if (this.isWarehouse) md = 'md2'
      return { [md]: true, 'xs12': true }
    }
  },
  methods: {
    toggleOverflowStyle (refName) {
      if (![...this.$refs[refName][0]?.classList || []].includes('text-overflow-hide')) return this.$refs[refName][0].classList.add('text-overflow-hide')
      this.$refs[refName][0].classList.remove('text-overflow-hide')
    },
    getWarehouseSitesNames (sites = [], index) {
      if (index === 0 || (sites && sites.includes('all'))) return ['ALL']
      return sites
        .map(site => 
          (this.warehouseSites.find(warehouseSite => warehouseSite.key === site) || {}).siteName
        )
    },
    showAddUserDialog () {
      this.roleEditDialog = true
      this.userInEdit = {}
      this.isEdit = false
    },
    showEditUserDialog (user) {
      this.roleEditDialog = true
      this.userInEdit = user
      this.isEdit = true
    },
    dispatchAndToast (promise) {
      return promise
        .catch(error => {
          this.$store.dispatch('showToast', {info: error.message})
          throw error
        })
    },
    addUser (user) {
      if (this.users && this.users.some(item => item.email === user.email)) return alert(this.$t('userAlreadyAdded'))
      return this.dispatchAndToast(this.$store.dispatch('addUserToWarehouse', user))
    },
    editUser (user) {
      return this.dispatchAndToast(this.$store.dispatch('editUserForWarehouse', user))
    },
    removeUser (user) {
      if (!confirm(this.$t('confirmRemoveUser'))) return
      return this.dispatchAndToast(this.$store.dispatch('removeUserFromWarehouse', user))
    },
    showToast (text, level = 'error') {
      this.toastText = text
      this.toastColor = level
      this.toastEnable = true
    }
  }
}
</script>

<style scoped>
.whiteColor {
    color: white !important;
  }
.text-overflow-hide {
  max-width: 200px;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Permissions.vue